import { render } from "./ThePopup.vue?vue&type=template&id=168498d2&scoped=true"
import script from "./ThePopup.vue?vue&type=script&lang=js"
export * from "./ThePopup.vue?vue&type=script&lang=js"

import "./ThePopup.vue?vue&type=style&index=0&id=168498d2&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/1mal1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168498d2"]])

export default __exports__